"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _store = require("@/api/store");
var _marketing = require("@/api/marketing");
var _logistics = require("@/api/logistics");
var _systemGroup = require("@/api/systemGroup");
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _creatTemplates = _interopRequireDefault(require("@/views/systemSetting/deliverGoods/freightSet/creatTemplates"));
var _index2 = _interopRequireDefault(require("../../appSetting/wxAccount/wxTemplate/index"));
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultObj = {
  image: '',
  sliderImages: [],
  videoLink: '',
  sliderImage: '',
  storeName: '',
  keyword: '',
  cateIds: [],
  // 商品分类id
  cateId: null,
  // 商品分类id传值
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  isBenefit: false,
  isNew: false,
  isGood: false,
  isHot: false,
  isBest: false,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    barCode: '',
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  isSub: false,
  content: '',
  specType: false,
  id: 0,
  couponIds: [],
  coupons: [],
  activity: ['默认', '秒杀', '砍价', '拼团']
};
var objTitle = {
  price: {
    title: '售价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
var _default = exports.default = {
  name: 'SortCreat',
  components: {
    Templates: _index2.default,
    CreatTemplates: _creatTemplates.default,
    Tinymce: _index.default
  },
  data: function data() {
    return {
      htmlKey: 0,
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      activity: {
        默认: 'red',
        秒杀: 'blue',
        砍价: 'green',
        拼团: 'yellow'
      },
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      checkboxGroup: [],
      recommend: [],
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 多规格
      ruleList: [],
      merCateList: [],
      // 商品分类筛选
      shippingList: [],
      // 运费模板
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      tempData: {
        page: 1,
        limit: 9999
      },
      manyTabTit: {},
      manyTabDate: {},
      grid2: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: 0,
      isChoice: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        storeName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        cateIds: [{
          required: true,
          message: '请选择商品分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        keyword: [{
          required: true,
          message: '请输入商品关键字',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }]
      },
      attrInfo: {},
      tableFrom: {
        page: 1,
        limit: 9999,
        keywords: ''
      },
      tempRoute: {},
      keyNum: 0,
      isAttr: false,
      showAll: false,
      videoLink: '',
      copyConfig: {},
      url: ''
    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    },
    oneFormBatch: function oneFormBatch() {
      var obj = [Object.assign({}, defaultObj.attrValue[0])];
      delete obj[0].barCode;
      return obj;
    }
  },
  watch: {
    'formValidate.attr': {
      handler: function handler(val) {
        this.watCh(val); //重要！！！
      },
      immediate: false,
      deep: true
    }
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    if (this.$route.params.id && this.formValidate.specType) {
      this.$watch('formValidate.attr', this.watCh);
    }
  },
  mounted: function mounted() {
    this.getCopyConfig();
    this.formValidate.sliderImages = [];
    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo();
    }
    this.getCategorySelect();
    this.getShippingList();
    this.getGoodsType();
  },
  methods: {
    addProduct: function addProduct() {
      var _this2 = this;
      if (this.url) {
        this.loading = true;
        this.copyConfig.copyType == 1 ? (0, _store.copyProductApi)({
          url: this.url
        }).then(function (res) {
          var info = res.info;
          _this2.formValidate = {
            image: _this2.$selfUtil.setDomain(info.image),
            sliderImage: info.sliderImage,
            storeName: info.storeName,
            keyword: info.keyword,
            cateIds: info.cateId ? info.cateId.split(',') : [],
            // 商品分类id
            cateId: info.cateId,
            // 商品分类id传值
            unitName: info.unitName,
            sort: 0,
            isShow: 0,
            isBenefit: false,
            isNew: false,
            isGood: false,
            isHot: false,
            isBest: false,
            tempId: info.tempId,
            attrValue: info.attrValue,
            attr: info.attr || [],
            selectRule: info.selectRule,
            isSub: false,
            content: _this2.$selfUtil.replaceImgSrcHttps(info.content),
            specType: info.attr.length ? true : false,
            id: info.id,
            giveIntegral: info.giveIntegral,
            ficti: info.ficti
          };
          if (info.isHot) _this2.checkboxGroup.push('isHot');
          if (info.isGood) _this2.checkboxGroup.push('isGood');
          if (info.isBenefit) _this2.checkboxGroup.push('isBenefit');
          if (info.isBest) _this2.checkboxGroup.push('isBest');
          if (info.isNew) _this2.checkboxGroup.push('isNew');
          var imgs = JSON.parse(info.sliderImage);
          var imgss = [];
          Object.keys(imgs).map(function (i) {
            imgss.push(_this2.$selfUtil.setDomain(imgs[i]));
          });
          _this2.formValidate.sliderImages = imgss;
          if (_this2.formValidate.attr.length) {
            _this2.oneFormBatch[0].image = _this2.$selfUtil.setDomain(info.image);
            for (var i = 0; i < _this2.formValidate.attr.length; i++) {
              _this2.formValidate.attr[i].attrValue = JSON.parse(_this2.formValidate.attr[i].attrValues);
            }
          }
          _this2.loading = false;
        }).catch(function () {
          _this2.loading = false;
        }) : importProductApi({
          url: this.url,
          form: this.form
        }).then(function (res) {
          _this2.formValidate = {
            image: _this2.$selfUtil.setDomain(res.image),
            sliderImage: res.sliderImage,
            storeName: res.storeName,
            keyword: res.keyword,
            cateIds: res.cateId ? res.cateId.split(',') : [],
            // 商品分类id
            cateId: res.cateId,
            // 商品分类id传值
            unitName: res.unitName,
            sort: 0,
            isShow: 0,
            isBenefit: false,
            isNew: false,
            isGood: false,
            isHot: false,
            isBest: false,
            tempId: res.tempId,
            attrValue: res.attrValue,
            attr: res.attr || [],
            selectRule: res.selectRule,
            isSub: false,
            content: res.content,
            specType: res.attr.length ? true : false,
            id: res.id,
            giveIntegral: res.giveIntegral,
            ficti: res.ficti
          };
          var imgs = JSON.parse(res.sliderImage);
          var imgss = [];
          Object.keys(imgs).map(function (i) {
            imgss.push(_this2.$selfUtil.setDomain(imgs[i]));
          });
          _this2.formValidate.sliderImages = imgss;
          if (_this2.formValidate.attr.length) {
            _this2.oneFormBatch[0].image = _this2.$selfUtil.setDomain(res.image);
            for (var i = 0; i < _this2.formValidate.attr.length; i++) {
              _this2.formValidate.attr[i].attrValue = JSON.parse(_this2.formValidate.attr[i].attrValues);
            }
          }
          _this2.loading = false;
        }).catch(function () {
          _this2.loading = false;
        });
      } else {
        this.$message.warning('请输入链接地址！');
      }
    },
    getCopyConfig: function getCopyConfig() {
      var _this3 = this;
      (0, _store.copyConfigApi)().then(function (res) {
        _this3.copyConfig = res;
      });
    },
    tabsHandleClick: function tabsHandleClick(tab, event) {
      this.currentTab = tab.name;
    },
    keyupEvent: function keyupEvent(key, val, index, num) {
      var re = /([0-9]+.[0-9]{2})[0-9]*/;
      switch (num) {
        case 1:
          this.oneFormBatch[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.oneFormBatch[index], key, String(val).replace(re, '$1'));
          break;
        case 2:
          this.OneattrValue[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.OneattrValue[index], key, String(val).replace(re, '$1'));
          break;
        default:
          this.ManyAttrValue[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.ManyAttrValue[index], key, String(val).replace(re, '$1'));
          break;
      }
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.isAttr = true;
      this.formValidate.coupons.splice(this.formValidate.coupons.indexOf(tag), 1);
      this.formValidate.couponIds.splice(this.formValidate.couponIds.indexOf(tag.id), 1);
    },
    addCoupon: function addCoupon() {
      var _this = this;
      this.$modalCoupon('wu', this.keyNum += 1, this.formValidate.coupons, function (row) {
        _this.formValidate.couponIds = [];
        _this.formValidate.coupons = row;
        row.map(function (item) {
          _this.formValidate.couponIds.push(item.id);
        });
      }, '');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.isDisabled ? '商品详情' : '编辑商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    onChangeGroup: function onChangeGroup() {
      this.checkboxGroup.includes('isGood') ? this.formValidate.isGood = true : this.formValidate.isGood = false;
      this.checkboxGroup.includes('isBenefit') ? this.formValidate.isBenefit = true : this.formValidate.isBenefit = false;
      this.checkboxGroup.includes('isBest') ? this.formValidate.isBest = true : this.formValidate.isBest = false;
      this.checkboxGroup.includes('isNew') ? this.formValidate.isNew = true : this.formValidate.isNew = false;
      this.checkboxGroup.includes('isHot') ? this.formValidate.isHot = true : this.formValidate.isHot = false;
    },
    watCh: function watCh(val) {
      var _this4 = this;
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.ManyAttrValue = this.attrFormat(val);
      this.ManyAttrValue.forEach(function (val, index) {
        var key = Object.values(val.attrValue).sort().join('/');
        if (_this4.attrInfo[key]) _this4.ManyAttrValue[index] = _this4.attrInfo[key];
      });
      this.attrInfo = [];
      this.ManyAttrValue.forEach(function (val) {
        _this4.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);
      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            if (!data) return;
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);
                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    cost: 0,
                    otPrice: 0,
                    stock: 0,
                    barCode: '',
                    weight: 0,
                    volume: 0,
                    brokerage: 0,
                    brokerage_two: 0
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });
                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }
                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                cost: 0,
                otPrice: 0,
                stock: 0,
                barCode: '',
                weight: 0,
                volume: 0,
                brokerage: 0,
                brokerage_two: 0,
                attrValue: _defineProperty({}, v['attrName'], vv)
              };
              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }
        return res;
      }
    },
    // 运费模板
    addTem: function addTem() {
      this.$refs.addTemplates.dialogVisible = true;
      this.$refs.addTemplates.getCityList();
    },
    // 添加规则；
    addRule: function addRule() {
      var _this = this;
      this.$modalAttr(this.formDynamics, function () {
        _this.productGetRule();
      });
    },
    // 选择规格
    onChangeSpec: function onChangeSpec(num) {
      this.isAttr = true;
      if (num) this.productGetRule();
    },
    // 选择属性确认
    confirm: function confirm() {
      var _this5 = this;
      this.isAttr = true;
      if (!this.formValidate.selectRule) {
        return this.$message.warning('请选择属性');
      }
      var data = [];
      this.ruleList.forEach(function (item) {
        if (item.id === _this5.formValidate.selectRule) {
          item.ruleValue.forEach(function (i) {
            data.push({
              attrName: i.value,
              attrValue: i.detail
            });
          });
        }
        _this5.formValidate.attr = data;
      });
    },
    //采集
    getCollect: function getCollect() {},
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this6 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this6.merCateList = _this6.addDisabled(res);
      });
    },
    //限制商品分类只能选择开启的
    addDisabled: function addDisabled(dropdownList) {
      var _this7 = this;
      var list = [];
      try {
        dropdownList.forEach(function (e, index) {
          var e_new = {
            id: e.id,
            name: e.name,
            level: e.level,
            pid: e.pid,
            sort: e.sort,
            status: e.status
          };
          if (!e.status) {
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              disabled: true
            });
          }
          if (e.child) {
            var childList = _this7.addDisabled(e.child);
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              child: childList
            });
          }
          list.push(e_new);
        });
      } catch (error) {
        console.log(error);
        return [];
      }
      return list;
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }
        item.label = item.name;
        return item;
      });
    },
    // 获取商品属性模板；
    productGetRule: function productGetRule() {
      var _this8 = this;
      (0, _store.templateListApi)(this.tableFrom).then(function (res) {
        var list = res.list;
        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }
        _this8.ruleList = list;
      });
    },
    // 运费模板；
    getShippingList: function getShippingList() {
      var _this9 = this;
      (0, _logistics.shippingTemplatesList)(this.tempData).then(function (res) {
        _this9.shippingList = res.list;
      });
    },
    showInput: function showInput(item) {
      this.$set(item, 'inputVisible', true);
    },
    onChangetype: function onChangetype(item) {
      var _this0 = this;
      if (item === 1) {
        this.OneattrValue.map(function (item) {
          _this0.$set(item, 'brokerage', null);
          _this0.$set(item, 'brokerageTwo', null);
        });
        this.ManyAttrValue.map(function (item) {
          _this0.$set(item, 'brokerage', null);
          _this0.$set(item, 'brokerageTwo', null);
        });
      } else {
        this.OneattrValue.map(function (item) {
          delete item.brokerage;
          delete item.brokerageTwo;
          _this0.$set(item, 'brokerage', null);
          _this0.$set(item, 'brokerageTwo', null);
        });
        this.ManyAttrValue.map(function (item) {
          delete item.brokerage;
          delete item.brokerageTwo;
        });
      }
    },
    // 删除表格中的属性
    delAttrTable: function delAttrTable(index) {
      this.ManyAttrValue.splice(index, 1);
    },
    // 批量添加
    batchAdd: function batchAdd() {
      // if (!this.oneFormBatch[0].pic || !this.oneFormBatch[0].price || !this.oneFormBatch[0].cost || !this.oneFormBatch[0].ot_price ||
      //     !this.oneFormBatch[0].stock || !this.oneFormBatch[0].bar_code) return this.$Message.warning('请填写完整的批量设置内容！');
      var _iterator = _createForOfIteratorHelper(this.ManyAttrValue),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var val = _step.value;
          this.$set(val, 'image', this.oneFormBatch[0].image);
          this.$set(val, 'price', this.oneFormBatch[0].price);
          this.$set(val, 'cost', this.oneFormBatch[0].cost);
          this.$set(val, 'otPrice', this.oneFormBatch[0].otPrice);
          this.$set(val, 'stock', this.oneFormBatch[0].stock);
          this.$set(val, 'barCode', this.oneFormBatch[0].barCode);
          this.$set(val, 'weight', this.oneFormBatch[0].weight);
          this.$set(val, 'volume', this.oneFormBatch[0].volume);
          this.$set(val, 'brokerage', this.oneFormBatch[0].brokerage);
          this.$set(val, 'brokerageTwo', this.oneFormBatch[0].brokerageTwo);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    // 添加按钮
    addBtn: function addBtn() {
      this.clearAttr();
      this.isBtn = true;
    },
    // 取消
    offAttrName: function offAttrName() {
      this.isBtn = false;
    },
    clearAttr: function clearAttr() {
      this.isAttr = true;
      this.formDynamic.attrsName = '';
      this.formDynamic.attrsVal = '';
    },
    // 删除规格
    handleRemoveAttr: function handleRemoveAttr(index) {
      this.isAttr = true;
      this.formValidate.attr.splice(index, 1);
      this.manyFormValidate.splice(index, 1);
    },
    // 删除属性
    handleClose: function handleClose(item, index, attrIndex) {
      if (index === 0 && item.length === 1) this.handleRemoveAttr(attrIndex);
      item.splice(index, 1);
    },
    // 添加规则名称
    createAttrName: function createAttrName() {
      this.isAttr = true;
      if (this.formDynamic.attrsName && this.formDynamic.attrsVal) {
        var data = {
          attrName: this.formDynamic.attrsName,
          attrValue: [this.formDynamic.attrsVal]
        };
        this.formValidate.attr.push(data);
        var hash = {};
        this.formValidate.attr = this.formValidate.attr.reduce(function (item, next) {
          /* eslint-disable */
          hash[next.attrName] ? '' : hash[next.attrName] = true && item.push(next);
          return item;
        }, []);
        this.clearAttr();
        this.isBtn = false;
      } else {
        this.$Message.warning('请添加完整的规格！');
      }
    },
    // 添加属性
    createAttr: function createAttr(num, idx) {
      this.isAttr = true;
      if (num) {
        this.formValidate.attr[idx].attrValue.push(num);
        var hash = {};
        this.formValidate.attr[idx].attrValue = this.formValidate.attr[idx].attrValue.reduce(function (item, next) {
          /* eslint-disable */
          hash[next] ? '' : hash[next] = true && item.push(next);
          return item;
        }, []);
        this.formValidate.attr[idx].inputVisible = false;
      } else {
        // this.$message.warning('请添加属性');
      }
    },
    //点击展示所有多规格属性
    showAllSku: function showAllSku() {
      if (this.isAttr == false) {
        this.isAttr = true;
        if (this.formValidate.specType && this.isAttr) this.watCh(this.formValidate.attr); //重要！！！
      } else if (this.isAttr == true) {
        this.isAttr = false;
        this.getInfo();
      }
    },
    // 详情
    getInfo: function getInfo() {
      var _this1 = this;
      this.fullscreenLoading = true;
      (0, _store.productDetailApi)(this.$route.params.id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var info, imgs, imgss, manyAttr, tmp, tmpTab;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                // this.isAttr = true;
                info = res;
                _this1.formValidate = {
                  image: _this1.$selfUtil.setDomain(info.image),
                  sliderImage: info.sliderImage,
                  sliderImages: JSON.parse(info.sliderImage),
                  storeName: info.storeName,
                  keyword: info.keyword,
                  cateIds: info.cateId.split(','),
                  // 商品分类id
                  cateId: info.cateId,
                  // 商品分类id传值
                  unitName: info.unitName,
                  sort: info.sort,
                  isShow: info.isShow,
                  isBenefit: info.isBenefit,
                  isNew: info.isNew,
                  isGood: info.isGood,
                  isHot: info.isHot,
                  isBest: info.isBest,
                  tempId: info.tempId,
                  attr: info.attr,
                  attrValue: info.attrValue,
                  selectRule: info.selectRule,
                  isSub: info.isSub,
                  content: info.content ? _this1.$selfUtil.replaceImgSrcHttps(info.content) : '',
                  specType: info.specType,
                  id: info.id,
                  giveIntegral: info.giveIntegral,
                  ficti: info.ficti,
                  coupons: info.coupons,
                  couponIds: info.couponIds,
                  activity: info.activity ? info.activity : ['默认', '秒杀', '砍价', '拼团']
                };
                (0, _marketing.marketingSendApi)({
                  type: 3
                }).then(function (res) {
                  if (_this1.formValidate.couponIds !== null) {
                    var ids = _this1.formValidate.couponIds.toString();
                    var arr = res.list;
                    var obj = {};
                    for (var i in arr) {
                      obj[arr[i].id] = arr[i];
                    }
                    var strArr = ids.split(',');
                    var newArr = [];
                    var _iterator2 = _createForOfIteratorHelper(strArr),
                      _step2;
                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var item = _step2.value;
                        if (obj[item]) {
                          newArr.push(obj[item]);
                        }
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                    _this1.$set(_this1.formValidate, 'coupons', newArr); //在编辑回显时，让返回数据中的优惠券id，通过接口匹配显示,
                  }
                });
                imgs = JSON.parse(info.sliderImage);
                imgss = [];
                Object.keys(imgs).map(function (i) {
                  imgss.push(_this1.$selfUtil.setDomain(imgs[i]));
                });
                _this1.formValidate.sliderImages = [].concat(imgss);
                if (_this1.getFileType(_this1.formValidate.sliderImages[0]) == 'video') {
                  //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
                  _this1.$set(_this1.formValidate, 'videoLink', _this1.formValidate.sliderImages[0]);
                  _this1.formValidate.sliderImages.splice(0, 1);
                }
                if (info.isHot) _this1.checkboxGroup.push('isHot');
                if (info.isGood) _this1.checkboxGroup.push('isGood');
                if (info.isBenefit) _this1.checkboxGroup.push('isBenefit');
                if (info.isBest) _this1.checkboxGroup.push('isBest');
                if (info.isNew) _this1.checkboxGroup.push('isNew');
                _this1.productGetRule();
                if (info.specType) {
                  _this1.formValidate.attr = info.attr.map(function (item) {
                    return {
                      attrName: item.attrName,
                      attrValue: item.attrValues.split(',')
                    };
                  });
                  _this1.ManyAttrValue = info.attrValue;
                  _this1.ManyAttrValue.forEach(function (val) {
                    val.image = _this1.$selfUtil.setDomain(val.image);
                    val.attrValue = JSON.parse(val.attrValue);
                    _this1.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
                  });
                  /***多规格商品如果被删除过sku，优先展示api返回的数据,否则会有没有删除的错觉***/
                  manyAttr = _this1.attrFormat(_this1.formValidate.attr);
                  if (manyAttr.length !== _this1.ManyAttrValue.length) {
                    _this1.$set(_this1, 'showAll', true);
                    _this1.isAttr = false;
                  } else {
                    _this1.isAttr = true;
                  }
                  /*******/
                  tmp = {};
                  tmpTab = {};
                  _this1.formValidate.attr.forEach(function (o, i) {
                    // tmp['value' + i] = { title: o.attrName }
                    // tmpTab['value' + i] = ''
                    tmp[o.attrName] = {
                      title: o.attrName
                    };
                    tmpTab[o.attrName] = '';
                  });

                  // 此处手动实现后台原本value0 value1的逻辑
                  _this1.formValidate.attrValue.forEach(function (item) {
                    for (var attrValueKey in item.attrValue) {
                      item[attrValueKey] = item.attrValue[attrValueKey];
                    }
                  });
                  _this1.manyTabTit = tmp;
                  _this1.manyTabDate = tmpTab;
                  _this1.formThead = Object.assign({}, _this1.formThead, tmp);
                } else {
                  _this1.OneattrValue = info.attrValue;
                  // this.formValidate.attr = [] //单规格商品规格设置为空
                }
                _this1.fullscreenLoading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this1.fullscreenLoading = false;
        _this1.$message.error(res.message);
      });
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning('最多选择10张图片！');
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning('最多选择10张图片！');
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.sattDir);
          });
        }
        if (tit === '3' && status === 'video') {
          var videoInfo = img[0];
          if (videoInfo.attType !== 'video/mp4') {
            this.$message.warning('请重新选择视频！');
          } else {
            _this.$set(_this.formValidate, 'videoLink', videoInfo.sattDir);
          }
        }
        if (tit === '1' && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    handleSubmitUp: function handleSubmitUp() {
      if (this.currentTab-- < 0) this.currentTab = 0;
      this.currentTab = this.currentTab.toString();
    },
    handleSubmitNest: function handleSubmitNest(name) {
      var _this10 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this10.currentTab++ > 3) _this10.currentTab = 0;
          _this10.currentTab = _this10.currentTab.toString();
        } else {
          if (!_this10.formValidate.store_name || !_this10.formValidate.cate_id || !_this10.formValidate.keyword || !_this10.formValidate.unit_name || !_this10.formValidate.store_info || !_this10.formValidate.image || !_this10.formValidate.slider_image) {
            _this10.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    //提交接口数据更新
    getFromData: function getFromData() {
      var _this11 = this;
      if (this.formValidate.specType && this.formValidate.attr.length < 1) return this.$message.warning('请填写多规格属性！');
      this.formValidate.cateId = this.formValidate.cateIds.join(',');
      if (this.formValidate.videoLink) {
        //如果有视频主图，将视频链接插入到轮播图第一的位置
        this.formValidate.sliderImages.unshift(this.formValidate.videoLink);
      }
      this.formValidate.sliderImage = JSON.stringify(this.formValidate.sliderImages);
      if (this.formValidate.specType) {
        this.formValidate.attrValue = this.ManyAttrValue;
        this.formValidate.attr = this.formValidate.attr.map(function (item) {
          return {
            attrName: item.attrName,
            id: item.id,
            attrValue: item.attrValue,
            attrValues: item.attrValue.join(',')
          };
        });
        for (var i = 0; i < this.formValidate.attrValue.length; i++) {
          this.$set(this.formValidate.attrValue[i], 'id', 0);
          this.$set(this.formValidate.attrValue[i], 'productId', 0);
          var attrValues = this.formValidate.attrValue[i].attrValue;
          this.$set(this.formValidate.attrValue[i], 'attrValue', JSON.stringify(attrValues));
          delete this.formValidate.attrValue[i].value0;
        }
      } else {
        this.formValidate.attr = [{
          attrName: '规格',
          attrValues: '默认',
          id: this.$route.params.id ? this.formValidate.attr[0].id : 0
        }];
        this.OneattrValue.map(function (item) {
          _this11.$set(item, 'attrValue', JSON.stringify({
            规格: '默认'
          }));
          //this.$set(item, 'productId', 0);
        });
        this.formValidate.attrValue = this.OneattrValue;
      }
    },
    // 提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this12 = this;
      this.onChangeGroup();
      this.getFromData();
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this12.fullscreenLoading = true;
          _this12.$route.params.id ? (0, _store.productUpdateApi)(_this12.formValidate).then(/*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    _this12.$message.success('编辑成功');
                    setTimeout(function () {
                      _this12.$router.push({
                        path: '/store/index'
                      });
                    }, 500);
                    _this12.fullscreenLoading = false;
                  case 1:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }()).catch(function (res) {
            _this12.fullscreenLoading = false;
            _this12.restoreData();
            if (_this12.formValidate.specType) _this12.ManyAttrValue = _this12.formValidate.attrValue;
          }) : (0, _store.productCreateApi)(_this12.formValidate).then(/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    _this12.$message.success('新增成功');
                    setTimeout(function () {
                      _this12.$router.push({
                        path: '/store/index'
                      });
                    }, 500);
                    _this12.fullscreenLoading = false;
                  case 1:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }()).catch(function (res) {
            _this12.fullscreenLoading = false;
            _this12.restoreData();
          });
        } else {
          if (!_this12.formValidate.storeName || !_this12.formValidate.cateId || !_this12.formValidate.keyword || !_this12.formValidate.unitName || !_this12.formValidate.image || !_this12.formValidate.sliderImages) {
            _this12.$message.warning('请填写完整商品信息！');
          }
        }
      });
    }),
    // 提交失败之后恢复数据
    restoreData: function restoreData() {
      for (var i = 0; i < this.formValidate.attrValue.length; i++) {
        var attrValues = this.formValidate.attrValue[i].attrValue;
        this.$set(this.formValidate.attrValue[i], 'attrValue', JSON.parse(attrValues));
      }
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = _toConsumableArray(this.formValidate.sliderImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.sliderImages = newItems;
      }
    },
    handleDragEnterFont: function handleDragEnterFont(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = _toConsumableArray(this.formValidate.activity);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.activity = newItems;
      }
    },
    getGoodsType: function getGoodsType() {
      var _this13 = this;
      /** 让商品推荐列表的name属性与页面设置tab的name匹配**/
      (0, _systemGroup.goodDesignList)({
        gid: 70
      }).then(function (response) {
        var list = response.list;
        var arr = [],
          arr1 = [];
        var listArr = [{
          name: '是否热卖',
          value: 'isGood',
          type: '5'
        }];
        var typeLists = [{
          name: '',
          value: 'isHot',
          type: '2'
        },
        //热门榜单
        {
          name: '',
          value: 'isBenefit',
          type: '4'
        },
        //促销单品
        {
          name: '',
          value: 'isBest',
          type: '1'
        },
        //精品推荐
        {
          name: '',
          value: 'isNew',
          type: '3'
        }]; //首发新品
        list.forEach(function (item) {
          var obj = {};
          obj.value = JSON.parse(item.value);
          obj.id = item.id;
          obj.gid = item.gid;
          obj.status = item.status;
          arr.push(obj);
        });
        arr.forEach(function (item1) {
          var obj1 = {};
          obj1.name = item1.value.fields[1].value;
          obj1.status = item1.status;
          obj1.type = item1.value.fields[3].value;
          arr1.push(obj1);
        });
        typeLists.forEach(function (item) {
          arr1.forEach(function (item1) {
            if (item.type == item1.type) {
              listArr.push({
                name: item1.name,
                value: item.value,
                type: item.type
              });
            }
          });
        });
        _this13.recommend = listArr;
      });
    },
    // 删除视频；
    delVideo: function delVideo() {
      var that = this;
      that.$set(that.formValidate, 'videoLink', '');
    },
    zh_uploadFile: function zh_uploadFile() {
      if (this.videoLink) {
        this.$set(this.formValidate, 'videoLink', this.videoLink);
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    }
  }
};